import { ClipboardList } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function RoleBlueprintNode({ data, selected }: Props) {
  const dims = data.capabilityDimensionsCount;
  return (
    <NodeShell
      node={data}
      icon={ClipboardList}
      selected={selected}
      footer={
        dims !== null && dims > 0 ? `${dims} ${dims === 1 ? "dimension" : "dimensions"}` : null
      }
    />
  );
}
